import React from "react";
import ProjectRouter from "./routers/router";
import AOS from "aos";
function App() {
  AOS.init();
  return <ProjectRouter />;
}

export default App;
